import React from "react";

const STORAGE_KEY = "timecard-time-format";
const SYNC_EVENT = "timecard-time-format-change";

export function useTimeFormat() {
  const [format, setFormat] = React.useState(
    () => localStorage.getItem(STORAGE_KEY) || "24h"
  );

  React.useEffect(() => {
    const handler = () => setFormat(localStorage.getItem(STORAGE_KEY) || "24h");
    window.addEventListener(SYNC_EVENT, handler);
    return () => window.removeEventListener(SYNC_EVENT, handler);
  }, []);

  const toggle = React.useCallback(() => {
    const next = (localStorage.getItem(STORAGE_KEY) || "24h") === "24h" ? "12h" : "24h";
    localStorage.setItem(STORAGE_KEY, next);
    window.dispatchEvent(new Event(SYNC_EVENT));
  }, []);

  const set = React.useCallback((fmt) => {
    localStorage.setItem(STORAGE_KEY, fmt);
    window.dispatchEvent(new Event(SYNC_EVENT));
  }, []);

  return { timeFormat: format, toggleTimeFormat: toggle, setTimeFormat: set };
}

export function resetTimeFormat() {
  localStorage.setItem(STORAGE_KEY, "24h");
  window.dispatchEvent(new Event(SYNC_EVENT));
}
